import { Component, Input } from '@angular/core';
import { currencify, round } from "../../helpers/common";
import { UtilsService } from "../../../../../common/src/lib/services";
import { ReportsService } from "../../services/reports.service";

@Component({
  selector: 'app-sales-summary',
  templateUrl: './sales-summary.component.html',
  styleUrls: ['./sales-summary.component.scss'],
})
export class SalesSummaryComponent {

  protected readonly currencify = currencify;
  protected readonly round = round;

  @Input() selectedTab!: string;
  @Input() data!: any;

  loading$ = this.reportsService.loading$;

  expendings = ['paymentsAll', 'paymentsPaid', 'paymentsPending'];

  infoToFill = {
    paymentsAll: [
      {
        id: 'p.all.paid',
        text: 'Paid',
        property: 'paid'
      },
      {
        id: 'p.all.pending',
        text: 'Pending',
        property: 'pending'
      },
      {
        id: 'p.all.total',
        text: 'Total Sales',
        property: 'totalSales'
      }
    ],
    paymentsPaid: [
      {
        id: 'p.paid.paid',
        text: 'Total paid',
        property: 'paid'
      },
      {
        id: 'p.paid.cc',
        text: 'CC',
        property: 'paidByCcPercent',
        subproperty: 'paidByCc'
      },
      {
        id: 'p.paid.cash',
        text: 'Cash',
        property: 'paidByCashPercent',
        subproperty: 'paidByCash'
      },
      {
        id: 'p.paid.checks',
        text: 'Checks',
        property: 'paidByCheckPercent',
        subproperty: 'paidByCheck'
      },
      {
        id: 'p.paid.others',
        text: 'Others',
        property: 'paidByOthersPercent',
        subproperty: 'paidByOthers'
      },
    ],
    paymentsPending: [
      {
        id: 'p.pending.pending',
        text: 'Pending',
        property: 'pending'
      },
      {
        id: 'p.pending.nc',
        text: 'Jobs',
        property: 'jobs'
      }
    ],
    commissionsPending: [
      {
        id: 'c.pending.pending',
        text: 'Total Pending',
        property: 'pending'
      }
    ],
    commissionsPaid: [
      {
        id: 'c.paid.paid',
        text: 'Total Paid',
        property: 'paid'
      }
    ],
    techPartsPending: [
      {
        id: 't.pending.pending',
        text: 'Total Pending',
        property: 'pending'
      }
    ],
    techPartsPaid: [
      {
        id: 't.paid.paid',
        text: 'Total Paid',
        property: 'paid'
      }
    ],
    tipsPending: [
      {
        id: 'tips.pending.pending',
        text: 'Total Pending',
        property: 'pending'
      }
    ],
    tipsPaid: [
      {
        id: 'tips.paid.paid',
        text: 'Total Paid',
        property: 'paid'
      }
    ],
    creditCardSettled: [
      {
        id: 'cc.settled.settled',
        text: 'Total settled',
        property: 'settled'
      }
    ],
    creditCardPending: [
      {
        id: 'cc.pending.pending',
        text: 'Total pending',
        property: 'pending'
      }
    ],
    creditCardPreChargebacks: [
      {
        id: 'cc.pre-chargebacks.pre-chargebacks',
        text: 'Total pre-chargebacks',
        property: 'preChargebacks'
      },
      {
        id: 'cc.pre-chargebacks.arbitration',
        text: 'Total arbitration',
        property: 'arbitration'
      }
    ],
    creditCardChargebacks: [
      {
        id: 'cc.chargebacks.chargebacks',
        text: 'Total chargebacks',
        property: 'chargebacks'
      },
      {
        id: 'cc.chargebacks.resolved',
        text: 'Total resolved',
        property: 'resolved'
      }
    ],
    creditCardRefunds: [
      {
        id: 'cc.refunds.refunds',
        text: 'Total refunds',
        property: 'refunds'
      }
    ],
    creditCardSurcharge: [
      {
        id: 'cc.surcharge.surcharge',
        text: 'Money saved',
        property: 'surcharge'
      }
    ],
  }

  showAll = false;

  constructor(
    private utilService: UtilsService,
    private reportsService: ReportsService,
  ) { }

  get isMobile() {
    return this.utilService.isMobile();
  }

  toggleShowAll() {
    this.showAll = !this.showAll;
  }

}
